import Switch from "@mui/material/Switch";
import { ToastType } from "../communication";

interface ToggleButtonProps {
	toggleFunction: () => void;
	disabled: boolean;
	label: string;
	displayToast?: (message: string, toastType: ToastType) => void;
	checked: boolean;
	message?: string
}

export function ToggleButton(props: ToggleButtonProps) {
	return (
		<div
			id="toggle"
			onClick={() => {
				if (props.message && props.disabled && props.displayToast !== undefined) {
					props.displayToast(
						props.message,
						"error"
					);
				}
			}}>
			<Switch
				className={"toggle-switch " + props.disabled ? "disabled" : ""}
				color={"default"}
				disabled={props.disabled}
				onChange={() => {
					props.toggleFunction();
				}}
				checked={props.checked}
			/>
			<span className="label">{props.label}</span>
		</div>
	);
}
